import React from 'react';
import { useSelector } from 'react-redux';
import DataSelection from '../../../common/DataSelection.jsx';
import WidgetInfoSettings from '../../settings_sidebar/WidgetInfoSettings.jsx';
import { useSetWidgetAttribute } from '../../hooks/useSetWidgetAttribute.js';
import CollapsibleSection from '../../../common/CollapsibleSection.jsx';
import WidgetTitleSettings from '../../settings_sidebar/WidgetTitleSettings.jsx';
import CommonField from '../../settings_sidebar/ag_chart/components/CommonField.jsx';
function ApplicantReportListWidgetSettings({ widgetId }) {
    const setAttribute = useSetWidgetAttribute(widgetId);
    const filters = useSelector(state => state.dashboard.widgets[widgetId].settings?.filters || []);

    return (<>
        <hr />
        <CollapsibleSection title={I18n.t('content_settings')}>
            <WidgetTitleSettings widgetId={widgetId} />
            <WidgetInfoSettings widgetId={widgetId} />
            <CommonField label={I18n.t('filters')}>
                <DataSelection
                    fields={[
                        { value: "Reports pending submission", label_key: "Reports pending submission", filter: "pending_fill" },
                        { value: "Reports being reviewed", label_key: "Reports being reviewed", filter: "pending_review" },
                    ]}
                    selected={filters}
                    onSelect={(e) => setAttribute('settings.filters', [...filters, e])}
                    onRemoveSelect={(e) => setAttribute('settings.filters', filters.filter((c) => c.value != e.value))}
                />
            </CommonField>
        </CollapsibleSection>
    </>);
};

export default ApplicantReportListWidgetSettings;